import React from 'react'
import { bindActionCreators } from 'redux'
import { useDispatch, useSelector } from 'react-redux'
import {
  loadGroup,
  joinGroup,
  leaveGroup,
  closeGroup,
  reOpenGroup,
  increasePrivacy,
  updateEndUserDigestFrequency
} from 'state/actions/groups'

import SearchWidget from 'components/SearchWidget'
import styles from './GroupPageExtraNav.css'
import { MembersIcon } from 'circle/MembersIcon'
import { WelcomeToCircleButton } from './WelcomeToCircleButton'
import styled from 'styled-components'
import { ChangeCirclePrivacyDialog, CircleMenu, CircleModalDialogsContextProvider, ConfirmDeleteCircle } from "lib-core"



const Wrapper = styled.div`
  /* display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 0.25em;
  padding-right: 0.25em; */
  && .MuiIconButton-root, && .MuiToggleButton-root {
    padding: 6px;
  }
`

const CircleDesktopExtraNav = (props) => {
  const {
    profile,
    group,
    place
  } = useSelector(selectForExtraNav)

  const {
    search,
  } = useExtraNavApi(props)

  const handleSearch = (filter) => {
    search({ group: group._id, filter })
  }

  const handleCancelSearch = () => {
    search({ group: group._id })
  }

  if (!group) {
    return null
  }

  if (profile) {
    return (
      <CircleModalDialogsContextProvider>
        <ChangeCirclePrivacyDialog />
        <ConfirmDeleteCircle />
        <Wrapper className={styles.group_extra_nav}>
          <MembersIcon />
          <SearchWidget
            data-intro="circle-search"
            hidden={place !== 'groups/group/posts' && place !== 'groups/group/reference'}
            onSearch={handleSearch}
            onCancelSearch={handleCancelSearch}
          />
          <WelcomeToCircleButton />
          <CircleMenu />
        </Wrapper>
      </CircleModalDialogsContextProvider>
    )
  }
  if (place === 'groups/group/posts') {
    return (
      <Wrapper className={styles.group_extra_nav}>
        <MembersIcon />
        <SearchWidget
          onSearch={handleSearch}
          onCancelSearch={handleCancelSearch}
        />
        <WelcomeToCircleButton />
      </Wrapper>

    )
  }
  return null
}

const selectForExtraNav = ({
  location: { type: place },
  session: { value: profile },
  group: { value: { group, membership } = {} }
}) => ({
  profile,
  group,
  membership,
  place
})

const useExtraNavApi = (props) => {
  const dispatch = useDispatch()
  return ({
    dispatch,
    joinGroup: bindActionCreators(joinGroup, dispatch),
    leaveGroup: bindActionCreators(leaveGroup, dispatch),
    closeGroup: bindActionCreators(closeGroup, dispatch),
    refresh: bindActionCreators(loadGroup, dispatch),
    reopenGroup: bindActionCreators(reOpenGroup, dispatch),
    search: bindActionCreators(props.searchAction, dispatch),
    increasePrivacy: bindActionCreators(increasePrivacy, dispatch),
    updateEndUserDigestFrequency: bindActionCreators(
      updateEndUserDigestFrequency,
      dispatch
    )
  })
}

export default CircleDesktopExtraNav
